import { useHistory } from "react-router-dom";
import { useStores } from "./index";
import { MenuItem } from "../services/menu/models";
import { isEmbedded } from "../utils/embed";

/**
 * Открытие карточки позиции.
 *
 * В обычном режиме карточка — это отдельный URL (`/alias/category/X/item/Y`),
 * чтобы работали прямые ссылки и системная кнопка «Назад». Во встроенном режиме
 * URL не трогаем: записи фрейма попадают в общую историю вкладки, и на iOS
 * закрытие карточки уводит назад страницу заведения (см. `utils/embed`).
 * Там карточка открывается и закрывается через стор.
 */
export const useOpenMenuItem = () => {
    const { menuStore, generalStore } = useStores();
    const history = useHistory();

    const buildUrl = (categoryId: number, itemId: number) => {
        if (generalStore.alias) {
            return `/${generalStore.alias}/category/${categoryId}/item/${itemId}`;
        }
        return `/menu/category/${categoryId}/item/${itemId}?orgId=${generalStore.organizationId}&branchId=${generalStore.organizationBranchId}&menuId=${generalStore.menuId}`;
    };

    const openMenuItem = (item: MenuItem) => {
        if (isEmbedded()) {
            menuStore.openModifiersPopup(item, () => menuStore.closeModifiersPopup());
            return;
        }
        history.push(buildUrl(item.data.menuCategoryId, item.id));
    };

    /** URL меню без открытой позиции — куда возвращаться из корзины. */
    const menuUrl = generalStore.alias
        ? `/${generalStore.alias}`
        : `/menu?orgId=${generalStore.organizationId}&branchId=${generalStore.organizationBranchId}&menuId=${generalStore.menuId}`;

    return { openMenuItem, menuUrl };
};

export default useOpenMenuItem;
